import { useState } from "react";
import { Button, Form, Modal, Row, Col } from "react-bootstrap";
import { ProgressBar } from "react-bootstrap";
// import { db } from "../firebase"; // Import Firestore
import { collection, addDoc, getFirestore } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import emailjs from "emailjs-com";

const db = getFirestore();
const storage = getStorage();

const steps = ["Your Information (1/5)", "Your Experience (2/5)", "Meet (3/5)", "Documentation (4/5)", "Congratulations (5/5)"];

export default function PriestRegistrationModal({ isOpen, onClose }) {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState("");
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    fullname: "",
    lineage: "",
    gender: "",
    phone: "",
    state: "",
    village: "",
    email: "",
    specialization: "",
    experience: "",
    profilePhoto: "",
  });

  const handleNext = async () => {

    // Ensure all required fields are filled before proceeding to submission
    if (step === 0) {
      if (!formData.fullname || !formData.lineage || !formData.gender || !formData.phone || !formData.state || !formData.village || !formData.email || !formData.specialization) {
        alert("Please fill in all required fields before proceeding.");
        return;
      }
    }

    if (step === 1) {
      if (!formData.experience) {
        alert("Please describe your experience before submitting.");
        return;
      }

      if (!imageURL) {
        alert("Please upload a profile photo before submitting.");
        return;
      }
    }


    if (step < 1) {
      setStep(step + 1);
    } else {
      console.log("Submitting Data1:", formData);
      await handleSubmit(); // Upload data on final step
    }

  };

  const handleSubmit = async () => {
    setLoading(true);
    console.log("Submitting Data2:", formData);
    try {
      await addDoc(collection(db, "priest_requests"), formData);
      // Send email via EmailJS
      await emailjs.send(
        "service_kxsob6t",        // Replace with your actual service ID
        "template_erpf3uk",       // Replace with your actual template ID
        {
          fullname: formData.fullname,
          experience: formData.experience,
          phone: formData.phone,
          email: formData.email,
          gender:formData.gender,
          lineage: formData.lineage,
          profilePhoto: formData.profilePhoto,
          state:formData.state,
          village: formData.village,
          specialization: formData.specialization,
        },
        "iTUAGGcFXyrJu_f0s"            // Replace with your actual public key
      );
      setStep(2); // Move to thank you message
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Error submitting request. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const uploadImage = async () => {
    if (!image) {
      alert("Please select an image first.");
      return;
    }

    setUploading(true);
    const storageRef = ref(storage, `priest_photos/${image.name}`);
    const uploadTask = uploadBytesResumable(storageRef, image);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Progress tracking (optional)
      },
      (error) => {
        console.error("Upload failed:", error);
        alert("Upload failed. Try again.");
        setUploading(false);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setImageURL(downloadURL);
          setFormData((prevData) => ({ ...prevData, profilePhoto: downloadURL }));
          setUploading(false);
        });
      }
    );
  };



  return (
    <Modal backdrop="static" show={isOpen} onHide={onClose} centered size="lg">
    <Modal.Header closeButton>
      <Modal.Title>{steps[step]}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ProgressBar variant="success" now={(step + 1) * 20} className="mb-4" />

      {step === 0 && (
        <div>
          {/* <h3 className="text-center mb-4">Your Information</h3> */}
          <Form>
            <Row className="mb-3">
              <Col>
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  name="fullname"
                  placeholder="Full Name"
                  onChange={handleChange}
                />
              </Col>
              <Col>
                <Form.Label>Mother's Name</Form.Label>
                <Form.Control
                  name="lineage"
                  placeholder="Mother's Name"
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Gender</Form.Label>
                <Form.Select name="gender" onChange={handleChange}>
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  {/* <option value="Other">Other</option> */}
                </Form.Select>
              </Col>
              <Col>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  placeholder="Ex. +2348108547713"
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Country/State/L.G.A</Form.Label>
                <Form.Control
                  name="state"
                  placeholder="Country/State/L.G.A"
                  onChange={handleChange}
                />
              </Col>
              <Col>
                <Form.Label>Village</Form.Label>
                <Form.Control
                  name="village"
                  placeholder="Village"
                  onChange={handleChange}
                />
              </Col>
              
            </Row>

            <Form.Label>Email</Form.Label>
            <Form.Control
              name="email"
              placeholder="Email"
              onChange={handleChange}
            />
            </Form>

  
        <Col style={{marginTop:15}}>
          <Form.Label>Specialization</Form.Label>
            <Form.Select name="specialization" onChange={handleChange}>
                <option value="">Select Specialization</option>
                <option value="Love, Marriage & Relationship">Love, Marriage & Relationship</option>
                <option value="Business & Start-up Consultancy">Business & Start-up Consultancy</option>
                <option value="Career & Financial Readings">Career & Financial Readings</option>
                <option value="General Life Readings">General Life Readings</option>
                <option value="Future & Past Insights">Future & Past Insights</option>
                <option value="Health & Wellness">Health & Wellness</option>
                <option value="My Spirituality">My Spirituality</option>
                <option value="Children & Parenting">Children & Parenting</option>
            </Form.Select>
        </Col>
        </div>
      )}

       {/* Step 1: Consultant Experience */}
       {step === 1 && (
          <div>
            {/* <h3 className="text-center mb-4">Your Experience</h3> */}
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Describe your experience as a spiritualist</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  name="experience"
                  placeholder="Write about your experience here..."
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Upload a Profile Photo</Form.Label>
                <Form.Control type="file" accept="image/*" onChange={handleImageChange} />
                {image && <Button className="mt-2" variant="primary" onClick={uploadImage} disabled={uploading}>Upload</Button>}
                {imageURL && <img src={imageURL} alt="Profile Preview" className="mt-3" style={{ width: "100px", borderRadius: "50%" }} />}
              </Form.Group>
            </Form>
          </div>
        )}

        {/* Step 2: Final Confirmation */}
        {/* Step 2: Final Confirmation */}
        {step === 2 && (
          <div className="text-center">
            {/* <h3 className="mb-4">Thank You</h3> */}
            <div className="text-start mx-auto" style={{ maxWidth: "600px", fontSize: "15px", lineHeight: "1.7", color: "#444" }}>
              {/* <p><strong>Ẹ káàbọ̀,</strong></p> */}

              <p>
                Welcome to Priests.Africa – Africa’s digital sanctuary for verified spiritual leaders.
              </p>

              <p>
              <strong> We are honored to receive your registration. please avoid sending multiple requests. </strong> Your interest in joining our sacred community is a testament to your calling and commitment to serve with authenticity.
              </p>

              <p>
                At Priest.Africa, we value <em>quality over quantity</em>, and as such, every application is carefully reviewed before moving to the next phase.
              </p>

              <p>
                <strong>What’s next?</strong><br />
                You will receive a follow-up prompt within <strong>48 hours</strong> inviting you to take part in our <strong>Integrity Test & Training</strong> — a core step to becoming a verified spiritual guide on our platform.
              </p>

              <p>
                Thank you for your patience and your dedication to spiritual excellence.
              </p>

              <p>
                Stay tuned, your sacred journey into global spiritual service begins soon.
              </p>

              <p><strong>Àṣẹ.</strong><br />— The Priests.Africa Team</p>
            </div>
          </div>
        )}

    </Modal.Body>

    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>Close</Button>
      {step < 2 && <Button variant="success" onClick={handleNext}>Next</Button>}
    </Modal.Footer>
  </Modal>
  );
}
